import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

export interface SegmentOption<T extends string> { value: T; label: ReactNode }

/** Segmented control for a choice within one screen (Issue / Waste, In / Out ...). One button per option. */
export function Segmented<T extends string>({ value, options, onChange, label }: {
  value: T; options: SegmentOption<T>[]; onChange: (value: T) => void; label: string;
}) {
  return (
    <div className="segmented" role="group" aria-label={label}>
      {options.map(o => (
        <button key={o.value} type="button" aria-pressed={o.value === value} className={o.value === value ? 'on' : ''} onClick={() => onChange(o.value)}>{o.label}</button>
      ))}
    </div>
  );
}

/** Segmented control whose options are pages (Purchasing on phone: Reorder / PRs / POs / Suppliers). */
export function SegmentedNav({ links, label }: { links: { to: string; label: string }[]; label: string }) {
  return (
    <nav className="segmented" aria-label={label}>
      {links.map(l => (
        <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? 'on' : '')}>{l.label}</NavLink>
      ))}
    </nav>
  );
}
